var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgAngleDownPurple(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 14,
    height: 8,
    viewBox: "0 0 14 8",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M7.83582 7.68831L13.6866 1.76623C14.1045 1.35065 14.1045 0.727273 13.6866 0.311688C13.2687 -0.103896 12.6418 -0.103896 12.2239 0.311688L7 5.4026L1.77612 0.311688C1.35821 -0.103896 0.731344 -0.103896 0.313433 0.311688C0.104478 0.519481 0 0.727273 0 1.03896C0 1.35065 0.104478 1.55844 0.313433 1.76623L6.16418 7.68831C6.68657 8.1039 7.31343 8.1039 7.83582 7.68831C7.73134 7.68831 7.73134 7.68831 7.83582 7.68831Z",
    fill: "#703CE5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAngleDownPurple);
export default __webpack_public_path__ + "static/media/angle-down-purple.230d1fdb206591608f354f57912984b3.svg";
export { ForwardRef as ReactComponent };